"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = (config, instance) => ({
  trackEvent(params) {
    return instance.post('/v2/capture', params, {
      baseURL: config.apiPrefixes.uaGW
    });
  }
});
exports.default = _default;